module.exports = __webpack_public_path__ + "img/logo.c36dba58.svg";